// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2jxsh","label":"Category_label__13t1Z","content":"Category_content__2SCgH","header":"Category_header__2riND","location":"Category_location__1TqKN"};